import { array } from "@visactor/vutils";

export const getVennSeriesDataKey = sets => array(sets).join(",");
//# sourceMappingURL=util.js.map
